import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureStoreId } from '../helpers/storeAttribution';
import IntroImageComponent from '../components/IntroImageComponent';

const HomePage = () => {
  const location = useLocation();

  // store_id z adresy uvodni stranky si odlozime pro registraci.
  useEffect(() => {
    captureStoreId(location.search);
  }, [location.search]);

  useEffect(() => {
    document.body.classList.add('hide-recaptcha');
    return () => document.body.classList.remove('hide-recaptcha');
  }, []);

  return <IntroImageComponent />;
};

export default HomePage;
